const resolveOverflowBottom = (scrollContainer, targetElement) => {
  if (!scrollContainer || !targetElement) return null;
  if (typeof scrollContainer.getBoundingClientRect !== 'function') return null;
  if (typeof targetElement.getBoundingClientRect !== 'function') return null;

  const containerRect = scrollContainer.getBoundingClientRect();
  const targetRect = targetElement.getBoundingClientRect();
  return targetRect.bottom - containerRect.bottom;
};

const scrollToBottomIfElementBelow = (scrollContainer, targetElement, options = {}) => {
  const padding = Number(options?.padding) || 0;
  const overflowBottom = resolveOverflowBottom(scrollContainer, targetElement);
  if (!Number.isFinite(overflowBottom) || overflowBottom <= 0) return false;

  scrollContainer.scrollTop = scrollContainer.scrollHeight + padding;
  return true;
};

const scheduleScrollToBottomIfElementBelow = (scrollContainer, targetElement, options = {}) => {
  if (typeof window === 'undefined') return null;
  return window.requestAnimationFrame(() => {
    scrollToBottomIfElementBelow(scrollContainer, targetElement, options);
  });
};

export { scheduleScrollToBottomIfElementBelow, scrollToBottomIfElementBelow };
